import {
  TIPOLOGIA_ELEMENTO_HIDRAULICO_DRENAJE_SUPERFICIAL,
  UNIDADES,
  SITUACIONES,
  SI_NO
} from './selectOptions'
import TYPES from '../../../../core/assets/assetTypes'
import comunIdentificacionFormFields from './comunIdentificacionFormFields'

export const identificacion = (workOrderFragment, familyFragment) => [
  ...comunIdentificacionFormFields(
    workOrderFragment,
    'drenajesSuperficiales',
    familyFragment,
    [
      TYPES.ARQUETAS_POZOS,
      TYPES.CUNETAS,
      TYPES.CAZ,
      TYPES.BORDILLOS,
      TYPES.BAJANTES
    ]
  ),

  {
    label: 'Tipología del elemento hidráulico',
    type: 'Select',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'identificacion',
      'tipologiaElementoHidraulico'
    ],
    meta: {
      options: TIPOLOGIA_ELEMENTO_HIDRAULICO_DRENAJE_SUPERFICIAL
    }
  },

  {
    label: 'Comentarios',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'identificacion',
      'comentarios'
    ]
  }
]

export const inspeccion = (workOrderFragment, familyFragment) => [
  {
    label: 'Medición',
    type: 'Number',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'inspeccion',
      'medicion'
    ]
  },

  {
    label: 'Unidad',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'inspeccion',
      'unidad'
    ],
    meta: {
      options: UNIDADES
    }
  },

  {
    label: 'Aspecto',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'inspeccion',
      'aspecto'
    ],
    meta: {
      options: SITUACIONES
    }
  },

  {
    label: 'Trabajos programados',
    type: 'Checkbox',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'inspeccion',
      'trabajosProgramados'
    ]
  },

  {
    label: 'Observaciones',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'inspeccion',
      'observaciones'
    ]
  },

  {
    label: 'Fotos antes',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'inspeccion',
      'antesFotos'
    ],
    meta: { isPhotos: true }
  }
]

export const ejecucion = (workOrderFragment, familyFragment) => [
  {
    label: 'Desbroce',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'ejecucion',
      'desbroce'
    ],
    meta: {
      placeholder: 'Sin especificar',
      options: SI_NO
    }
  },

  {
    label: 'Desbroce PK Inicio',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'ejecucion',
      'desbrocePkInicio'
    ]
  },

  {
    label: 'Desbroce PK Fin',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'ejecucion',
      'desbrocePkFin'
    ]
  },

  {
    label: 'Medición Desbroce',
    type: 'Number',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'ejecucion',
      'medicionDesbroce'
    ]
  },

  {
    label: 'Unidad Desbroce',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'ejecucion',
      'unidadDesbroce'
    ],
    meta: {
      options: UNIDADES
    }
  },

  {
    label: 'Limpieza',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'ejecucion',
      'limpieza'
    ],
    meta: {
      placeholder: 'Sin especificar',
      options: SI_NO
    }
  },

  {
    label: 'Limpieza PK Inicio',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'ejecucion',
      'limpiezaPkInicio'
    ]
  },

  {
    label: 'Limpieza PK Fin',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'ejecucion',
      'limpiezaPkFin'
    ]
  },

  {
    label: 'Medición Limpieza',
    type: 'Number',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'ejecucion',
      'medicionLimpieza'
    ]
  },

  {
    label: 'Unidad Limpieza',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'ejecucion',
      'unidadLimpieza'
    ],
    meta: {
      options: UNIDADES
    }
  },

  {
    label: 'Trabajos programados',
    type: 'Checkbox',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'ejecucion',
      'trabajosProgramados'
    ]
  },

  {
    label: 'Observaciones',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'ejecucion',
      'observaciones'
    ]
  }
]

export const validacion = (workOrderFragment, familyFragment) => [
  {
    label: 'Responsable Contratista',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'validacion',
      'responsableContratista'
    ]
  },

  {
    label: 'Fecha',
    type: 'Date',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'validacion',
      'fecha'
    ]
  },

  {
    label: 'Situación de la entrada',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'validacion',
      'situacionEntrada'
    ],
    meta: {
      options: SITUACIONES
    }
  },

  {
    label: 'Auditado',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'validacion',
      'auditado'
    ],
    meta: {
      placeholder: 'Sin especificar',
      options: SI_NO
    }
  },

  {
    label: 'Comentarios',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'validacion',
      'comentarios'
    ]
  },

  {
    label: 'Observaciones',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'validacion',
      'observaciones'
    ]
  },

  {
    label: 'Fotos entrada',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'validacion',
      'fotosEntrada'
    ],
    meta: { isPhotos: true }
  },

  {
    label: 'Fotos salida',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'validacion',
      'fotosSalida'
    ],
    meta: { isPhotos: true }
  },

  {
    label: 'Fotos',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesSuperficiales',
      familyFragment,
      'validacion',
      'fotos'
    ],
    meta: { isPhotos: true }
  }
]
